import { createApi } from '@reduxjs/toolkit/dist/query/react'
import { getBaseQueryAuth } from 'helpers/rtkQueryHelpers'

import { MarkAsReadError, MarkAsReadSuccess } from '../types/noticeDto'
import { NoticeHistory } from '../types/noticeHistory'

export const noticeApi = createApi({
  reducerPath: 'noticeHistory',
  baseQuery: getBaseQueryAuth,
  tagTypes: ['noticeHistory'],
  refetchOnMountOrArgChange: true,
  endpoints: builder => ({
    // получение списка уведомлений
    getNoticeHistory: builder.query<NoticeHistory, void>({
      query: () => ({
        url: '/v1/customer/history-notification/list',
        method: 'GET',
      }),
      providesTags: ['noticeHistory'],
    }),
    // помечать уведомление просмотренным
    markAsReadHistoryItem: builder.mutation<
      MarkAsReadSuccess | MarkAsReadError,
      number[]
    >({
      query: ids => ({
        url: `/v1/customer/history-notification/mark-as-read`,
        method: 'PUT',
        body: {
          ids: ids,
        },
      }),
      invalidatesTags: ['noticeHistory'],
    }),
  }),
})

export const { useGetNoticeHistoryQuery, useMarkAsReadHistoryItemMutation } =
  noticeApi
